import { render, staticRenderFns } from "./ScrapingRulesList.vue?vue&type=template&id=4cdff41e"
import script from "./ScrapingRulesList.vue?vue&type=script&lang=js"
export * from "./ScrapingRulesList.vue?vue&type=script&lang=js"
import style0 from "./ScrapingRulesList.vue?vue&type=style&index=0&id=4cdff41e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports